import PulseLoader from "react-spinners/PulseLoader"
import useTitle from "../../hooks/useTitle"
import { useGetGroupsQuery } from "../groups/groupsApiSlice"
import ChangeMultiGroupForm from "./ChangeMultiGroupForm"


function ChangeMultiGroup() {
    useTitle('geshtop-Exercise: New User')


    const { groups } = useGetGroupsQuery("groupsList", {
        selectFromResult: ({ data }) => ({
            groups: data?.ids.map(id => data?.entities[id])
        }),
    })
    if (!groups?.length) return <PulseLoader color={"#FFF"} />

    const content = <ChangeMultiGroupForm groups={groups} />

    return content
}

export default ChangeMultiGroup